import React from 'react';
import { useStyletron } from 'baseui';
import footerLogo from "../logoImage2.png";

const Footer = () => {
    const [css] = useStyletron();

    const handleHomeClick = (event) => {
        if (window.location.pathname === "/") {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: "auto" });
        }
    };

    const sectionStyle = css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--apt300-orange-gradient)',
        backgroundAttachment: 'scroll',
        '@media (max-width: 760px)': {
            minHeight: '100%',
            padding: '2rem 1rem',
        },
    });

    return (
        <div className={sectionStyle}>
            <a
                href="/#top"
                className="apt300-logo-button apt300-footer-logo-button"
                onClick={handleHomeClick}
                aria-label="Go to the APT 300 home page"
            >
                <img
                    src={footerLogo}
                    alt="APT 300"
                    className={css({
                        display: 'block',
                        width: '10%',
                        '@media (max-width: 660px)': {
                            width: '20%',
                        },
                        '@media (min-width: 661px) and (max-width: 1024px)': {
                            width: '20%',
                        },
                    })}
                />
            </a>
        </div>
    );
};

export default Footer;
